<template>
  <EditorPageWrapper
    wrapperId="messages"
    :iconComponent="AppGuideIcon"
    title="MESSAGES"
    page="messages"
    collection="messages"
    multiple
  />
</template>

<script>
  import EditorPageWrapper from '@/components/utilities/EditorPageWrapper.vue'
  import AppGuideIcon from '@/assets/icons/AppGuideIcon.vue'

  export default {
    name: 'Messages',
    components: {
      EditorPageWrapper,
    },
    setup() {
      return {
        AppGuideIcon,
      }
    },
  }
</script>

<style>
  .section-heading h1 {
    display: flex;
    align-items: center;
  }
  .jrnyorient-icon {
    margin-right: 10px;
  }
</style>
